import React from "react";

function TaskDisplaySwitch({
  value = "order",
  onChange,
  className = "",
}) {
  const isThemeMode = value === "theme";

  const handleToggle = () => {
    if (typeof onChange === "function") {
      onChange(isThemeMode ? "order" : "theme");
    }
  };

  return (
    <div
      className={`task-display-switch ${className}`.trim()}
      style={styles.container}
    >
      <div style={styles.title}>⚙ Affichage</div>

      <div style={styles.switchRow}>
        <span
          style={{
            ...styles.label,
            ...(isThemeMode ? styles.inactiveLabel : styles.activeLabel),
          }}
        >
          Ordre
        </span>

        <button
          type="button"
          role="switch"
          aria-checked={isThemeMode}
          aria-label={
            isThemeMode
              ? "Afficher les tâches par ordre"
              : "Afficher les tâches par thème"
          }
          title={
            isThemeMode
              ? "Passer à l’affichage par ordre"
              : "Passer à l’affichage par thème"
          }
          onClick={handleToggle}
          style={{
            ...styles.switchButton,
            ...(isThemeMode ? styles.themeSwitch : styles.orderSwitch),
          }}
        >
          <span
            aria-hidden="true"
            style={{
              ...styles.thumb,
              transform: isThemeMode
                ? "translateX(26px)"
                : "translateX(0)",
            }}
          />
        </button>

        <span
          style={{
            ...styles.label,
            ...(isThemeMode ? styles.activeLabel : styles.inactiveLabel),
          }}
        >
          Thème
        </span>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    minWidth: "210px",
    padding: "11px 14px 12px",
    backgroundColor: "#ffffff",
    border: "1px solid #d8d8d8",
    borderRadius: "12px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
    color: "#333333",
    fontFamily: "inherit",
    userSelect: "none",
  },

  title: {
    width: "100%",
    paddingBottom: "7px",
    borderBottom: "1px solid #eeeeee",
    color: "#666666",
    fontSize: "0.78rem",
    fontWeight: 800,
    letterSpacing: "0.04em",
    textAlign: "center",
    textTransform: "uppercase",
  },

  switchRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    whiteSpace: "nowrap",
  },

  label: {
    minWidth: "48px",
    fontSize: "0.9rem",
    fontWeight: 700,
    textAlign: "center",
    transition: "opacity 0.2s ease, color 0.2s ease",
  },

  activeLabel: {
    color: "#222222",
    opacity: 1,
  },

  inactiveLabel: {
    color: "#8a8a8a",
    opacity: 0.65,
  },

  switchButton: {
    position: "relative",
    width: "52px",
    height: "26px",
    padding: 0,
    border: "2px solid #333333",
    borderRadius: "999px",
    cursor: "pointer",
    flexShrink: 0,
    outlineOffset: "3px",
    transition: "background-color 0.2s ease",
  },

  orderSwitch: {
    backgroundColor: "#f1f1f1",
  },

  themeSwitch: {
    backgroundColor: "#e51010",
  },

  thumb: {
    position: "absolute",
    top: "3px",
    left: "3px",
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    backgroundColor: "#222222",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.35)",
    transition: "transform 0.22s ease",
  },
};

export default TaskDisplaySwitch;
